import { DetailSection, ContactField } from './content-box'
import { formatNameForDisplay } from 'lib/text-display'
import PersonOutlineIcon from 'components/material-symbol/icons/PersonOutline'
import CalendarTodayOutlinedIcon from 'components/material-symbol/icons/CalendarToday'
import HeightOutlinedIcon from 'components/material-symbol/icons/Height'
import PeopleOutlineIcon from 'components/material-symbol/icons/PeopleOutline'
import RecordVoiceOverOutlinedIcon from 'components/material-symbol/icons/ThreeP'
import AccessibleForwardOutlinedIcon from 'components/material-symbol/icons/AccessibleForward'
import { useAuth } from 'lib/auth'
import { genderOptions, pronounOptions } from './constants'

export default function AdditionalInformation({ demographics, joinedAt }) {
  const {
    studentGender,
    studentGenderSelfDescription,
    studentHeightInches,
    studentPhysicalLimitations,
    studentProunounPreference,
  } = demographics
  const { user } = useAuth()
  const coachName = formatNameForDisplay(`${user.firstName} ${user.lastName}`)

  const heightInFeet = Math.floor(studentHeightInches / 12)
  const heightInInches = studentHeightInches % 12
  const heightText = studentHeightInches
    ? `${heightInFeet}' ${heightInInches}"`
    : null

  const genderValue = genderOptions.find(opt => opt.value === studentGender)
    ?.label
  const genderText = studentGenderSelfDescription
    ? `${genderValue}: (${studentGenderSelfDescription})`
    : genderValue

  const pronounValue = pronounOptions.find(
    opt => opt.value === studentProunounPreference,
  )?.label

  const joinedText = joinedAt
    ? new Date(joinedAt).toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    })
    : null

  return (
    <DetailSection title="About" compact stacked>
      <ContactField
        icon={PersonOutlineIcon}
        label="Coach"
        value={coachName}
        testId="student-about-coach"
      />
      {joinedText && (
        <ContactField
          icon={CalendarTodayOutlinedIcon}
          label="Joined"
          value={joinedText}
        />
      )}
      {heightText && (
        <ContactField
          icon={HeightOutlinedIcon}
          label="Height"
          value={heightText}
        />
      )}
      {genderText && (
        <ContactField
          icon={PeopleOutlineIcon}
          label="Gender"
          value={genderText}
        />
      )}
      {pronounValue && (
        <ContactField
          icon={RecordVoiceOverOutlinedIcon}
          label="Pronouns"
          value={pronounValue}
        />
      )}
      {studentPhysicalLimitations && (
        <ContactField
          icon={AccessibleForwardOutlinedIcon}
          label="Physical Limitations"
          value={studentPhysicalLimitations}
        />
      )}
    </DetailSection>
  )
}
